import type { CSSProperties } from "react";
import { FaCheckCircle, FaArrowRight } from "react-icons/fa";
import { trackEvent } from "../services/firebase";
import "./SafetyTipsBar.css";

const COMPANY_NAME = import.meta.env.VITE_COMPANY_NAME;
const REPAY_NOW_URL = `${import.meta.env.VITE_WEBSITE_LINK}/repay-now`;
const PRIMARY_COLOR = import.meta.env.VITE_PRIMARY_COLOR || "#5B1A8B";
const SECONDARY_COLOR = import.meta.env.VITE_SECONDARY_COLOR || "#6CC24A";

const POINTS = [
  { lead: "Repay only on our official website.", rest: `${COMPANY_NAME} has one secure repayment page.` },
  { lead: "No payments on calls, SMS or WhatsApp.", rest: `${COMPANY_NAME} never asks for money there.` },
  { lead: "Never pay to personal UPI IDs or bank accounts.", rest: `${COMPANY_NAME} is not liable for payments made elsewhere.` },
];

const PointGroup = ({ hidden }: { hidden?: boolean }) => (
  <div className="pay-safe-bar__group" aria-hidden={hidden}>
    {POINTS.map((point) => (
      <span key={point.lead} className="pay-safe-bar__point">
        <FaCheckCircle aria-hidden="true" />
        <span>
          <strong>{point.lead}</strong> {point.rest}
        </span>
      </span>
    ))}
  </div>
);

const SafetyTipsBar = () => {
  const colors = {
    "--pay-primary": PRIMARY_COLOR,
    "--pay-secondary": SECONDARY_COLOR,
  } as CSSProperties;

  return (
    <>
      <div className="pay-safe-spacer" />
      <div className="pay-safe-bar" style={colors} role="region" aria-label="Payment safety notice">
        <span className="pay-safe-bar__chip">
          <span className="pay-safe-bar__dot" aria-hidden="true" />
          <span className="pay-safe-bar__chip-text">Pay safe</span>
        </span>
        <div className="pay-safe-bar__viewport">
          <div className="pay-safe-bar__track">
            <PointGroup />
            <PointGroup hidden />
          </div>
        </div>
        <a
          href={REPAY_NOW_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="pay-safe-bar__cta"
          onClick={() => trackEvent("repay_now_click", { location: "pay_safe_bar" })}
        >
          Repay <span className="pay-safe-bar__cta-word">safely</span>
          <FaArrowRight aria-hidden="true" />
        </a>
      </div>
    </>
  );
};

export default SafetyTipsBar;
